import React, {useEffect, useState} from "react";
import Menu from './menu' ;
import { useNavigate, useLocation } from "react-router-dom";
import { FaCircleUser } from "react-icons/fa6";
import { MdLiveTv } from "react-icons/md";
import { CiHome } from "react-icons/ci";
import { FaAngleDown } from "react-icons/fa";
import { CiMobile3 } from "react-icons/ci";
import UserInfo from "./userInfo";
import { loginApi, getBalanceApi } from "../../services/authApi";
import { t, setLang, getLang } from "../../lang";

const itemData = [
    {
        name: "menu.home",
        icon: <img src="/img/icons/home.svg" alt="home" />,
        link: "/",
    },
    {
        name: "menu.new_game",
        icon: <img src="/img/icons/Frame.svg" alt="gift" />,
        link: "/newgame",
    },
    {
        name: "menu.favorite_game",
        icon: <img src="/img/icons/favorite.svg" alt="favorite" />,
        link: "/favorite",
    },
    {
        name: "menu.slot",
        icon: <img src="/img/icons/octicon_goal-24.svg" alt="gift" />,
        link: "/slot",
    },
    {
        name: "menu.live",
        icon: <img src="/img/icons/live.svg" alt="live" />,
        link: "/live",
    },
];


const showErrorToast = (message) => {
    window.dispatchEvent(
        new CustomEvent("showNotification", {
        detail: {
            message,
            type: "error",
        },
        })
    );
};

export default function Header({ showLogin, isAuthenticated, userData, userBalance, onSignOut, onLoginSuccess }) {
    const [ time, setTime ] = useState( new Date() ) ;
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [lang, setLangState] = useState(getLang());
    const navigate = useNavigate() ;
    const location = useLocation() ;
    useEffect(() => {
        if (!isAuthenticated) {
            showLogin();
        }
    }, [isAuthenticated]);
    const navigatePage = ( link ) => e => {
        navigate( link, { replace : true } ) ;
    }
    const [ showMenu, setShowMenu ] = useState( false ) ;
    useEffect(() => {
        const handler = () => setLangState(getLang());
        window.addEventListener("langChanged", handler);
        return () => window.removeEventListener("langChanged", handler);
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");
        try {
        // Make POST request with query parameters and request body
        const response = await loginApi(username, password);

        if (response.data.status === true) {
            // Save token and user data to localStorage
            const { token, token_type, user } = response.data.data;
            localStorage.setItem('authToken', token);
            localStorage.setItem('tokenType', token_type);
            localStorage.setItem('userData', JSON.stringify(user));
            localStorage.setItem('isAuthenticated', 'true');

            // Fetch user balance info after successful login
            try {
            const balanceResponse = await getBalanceApi();
            
            if (balanceResponse.data && balanceResponse.data.status === true) {
                const balanceData = balanceResponse.data.data;
                localStorage.setItem('userBalance', JSON.stringify(balanceData));
                
                // Dispatch custom event for same-tab updates
                window.dispatchEvent(new CustomEvent('balanceUpdated', {
                detail: { balanceData }
                }));
                
                // Call success callback with user data and balance data
                if (onLoginSuccess) {
                    onLoginSuccess(user, token, balanceData);
                }
            } else {
                // Call success callback even if balance fetch fails
                if (onLoginSuccess) {
                    onLoginSuccess(user, token, null);
                }
            }
            } catch (balanceError) {
            console.error("Error fetching balance:", balanceError);
            // Call success callback even if balance fetch fails
            if (onLoginSuccess) {
                onLoginSuccess(user, token, null);
            }
            }
        } else {
            setError(response.data.message || "Login failed");
             showErrorToast(response.data.message || "Login failed");
        }
        } catch (err) {
        // Handle error response
        if (err.response && err.response.data) {
            setError(err.response.data.message || "Login failed. Please check your credentials.");
        } else {
            setError("Network error. Please try again.");
        }
            const message =
            err.response?.data?.message ||
            "Network error. Please try again.";

            setError(message);
            showErrorToast(message);
        } finally {
        setIsLoading(false);
        }
    };

    const handleHeaderLogin = (e) => {
        e?.preventDefault();
        if (!username.trim() || !password.trim()) {
            showLogin();
            return;
        }

        handleSubmit(e);
    };


    return(
        <>
        <div className="header">
            <div className="header-logo">
                <div className="user-mobile-show menu-toggle-icon" onClick={ () => setShowMenu( !showMenu ) }>
                    {showMenu ? (
                        <span className="menu-close-icon">×</span>
                    ) : (
                        <img src="/img/vector.svg" alt="menu" />
                    )}
                </div>
                <img src="/img/kingdom_logo.png" alt="logo" onClick={ () => navigate( '/' ) } />
                <span className="user-mobile-show">
                </span>
                {/* <FaCircleUser className="user-mobile-show"/> */}
            </div>
            {/*{!isAuthenticated && (*/}
            {/*    <div className="user-sign"> */}
            {/*     */}
            {/*        <div className="user-name">*/}
            {/*            <span>{t("common.user_name")}</span>*/}
            {/*            /!* <span>User Name</span> *!/*/}
            {/*            <input*/}
            {/*                type="text"*/}
            {/*                value={username}*/}
            {/*                onChange={(e) => setUsername(e.target.value)}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*        <div className="user-password">*/}
            {/*            <span>{t('common.pass_word')}</span>*/}
            {/*            /!* <span>Password</span> *!/*/}
            {/*             <input*/}
            {/*                type="password"*/}
            {/*                value={password}*/}
            {/*                onChange={(e) => setPassword(e.target.value)}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*        <div className="user-sign-btn">*/}
            {/*            <div className="btn_login" onClick={handleHeaderLogin}>*/}
            {/*                <span>{t("common.login")}</span>*/}
            {/*            </div>*/}
            {/*            /!* <div className="btn_login">*/}
            {/*                <span>Sign Up</span>*/}
            {/*            </div> *!/*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*)}*/}
            <div style={{ display: "flex", alignItems: "center" }}>
            <div className="user-timezone">
                {isAuthenticated && (
                    <UserInfo userData={userData} userBalance={userBalance} />
                )}
                {/* <div className="timezone-time">{ time.toISOString() }</div> */}
                    {isAuthenticated && (
                        <div className="btn_login" style={{marginLeft: "20px"}} onClick={ onSignOut }>
                            <span>{t('common.sign_out')}</span>
                        </div>
                    )}
                {/* <div className="user-country-flag">
                    <img src="/img/flags/default.png" alt="countryFlag" />
                    <FaAngleDown />
                </div> */}
            </div>
            </div>
            <div style={{ marginLeft: 40, marginRight: 40 }}>
                <select
                    value={lang}
                    onChange={(e) => setLang(e.target.value)}
                    style={{
                        padding: "6px 10px",
                        borderRadius: 6,
                        cursor: "pointer"
                    }}
                >
                    <option value="en">{t("menu.english")}</option>
                    <option value="ja">{t("menu.japanese")}</option>
                </select>
            </div>
        </div>
        <div className="header-nav">
            {/* <div className="nav-item-mobile">
                <CiMobile3 />
                Mobile Version
            </div> */}
            {
                itemData.map( ( item, index ) => (
                    <div 
                        className={`nav-item ${location.pathname === item.link ? 'active' : ''}`}
                        key={ index } 
                        onClick={ navigatePage( item.link ) }
                    >
                        { item.icon }
                        <span>{t(item.name)}</span>
                    </div>
                ) )
            }
        </div>

        {/* Mobile Version */}
        {/* <div className="header-nav-mobile"> */}
            {/* <div className="nav-item-change-mode">
                <img src="/icons/pc.svg" alt="pc"/>
                PC Version
            </div> */}
            {/* <div></div>
            <div className="user-timezone-mobile">
                <div className="timezone-time">{ time.toISOString() }</div>
                <div className="user-country-flag">
                    <img src="/img/flags/default.png" alt="countryFlag" />
                    <FaAngleDown />
                </div>
            </div>
        </div> */}
        <Menu showHandle={ showMenu } setShowHandle = { setShowMenu } showLogin={showLogin} isAuthenticated={isAuthenticated} userData={userData} userBalance={userBalance} onSignOut={onSignOut} />
    </>
    )
} ;